/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { blockingActionV4NameSchema } from './blockingActionV4NameSchema'
import { loginActionV4NameSchema } from './loginActionV4NameSchema'
import { myPageV4Schema } from './myPageV4Schema'
import { orgTypeNameSchema } from './orgTypeNameSchema'
import { roleTypeAdvancedNameSchema } from './roleTypeAdvancedNameSchema'

export const meV4Schema = z
  .object({
    displayName: z.string().min(1).default(''),
    initials: z.string().min(1).default(''),
    email: z.string().min(1).default(''),
    lang: z
      .string()
      .min(0)
      .default('')
      .describe(
        'UI language code stored for the user. An empty string means no saved preference; the client uses its local preference or Latvian fallback.'
      ),
    roleType: orgTypeNameSchema.describe(
      'Active context category: "Org" / "Edu" / "Intern" (student) / "Edy365".'
    ),
    roles: z
      .array(roleTypeAdvancedNameSchema)
      .default([])
      .describe(
        'Role names the user holds in the active context: "Admin" / "Manager" / "User" / "Intern".'
      ),
    pages: z
      .array(myPageV4Schema)
      .default([])
      .describe(
        'UI pages of the active role/org context, each with its events badge (-1 = no events function).'
      ),
    isSupportCase: z
      .boolean()
      .default(false)
      .describe(
        'True when this session is a support impersonation (started via the EDY365AllUsers loginAs action).'
      ),
    hasPortrait: z
      .boolean()
      .default(false)
      .describe(
        'Whether the user has a portrait image (User.HasImage — set by the portrait upload).'
      ),
    supportCaseId: z
      .string()
      .default('')
      .describe(
        'The support case number of the impersonation session ("" outside support mode) — for the UI banner.'
      ),
    loginActions: z
      .array(loginActionV4NameSchema)
      .default([])
      .describe(
        'User-level gates still outstanding, by NAME (e.g. "MustChangePassword", "MustAcceptUserTerms"). The auth\r\npipeline also rejects gated requests with a redirectAction; this is the same truth in the payload so the\r\nclient can render the right screen without waiting for a rejection.'
      ),
    blockingActions: z
      .array(blockingActionV4NameSchema)
      .default([])
      .describe(
        'Gates coming from the ACTIVE ORG\'s data, by NAME (e.g. "MustAcceptOrgTerms"). Reported, not enforced\r\nserver-side — the client blocks on them, which is how the pre-existing blocking actions work too. The\r\nconsent ones appear only for a role holding Admin, since nobody else may consent for the institution.'
      ),
  })
  .describe(
    'Shape returned by `GET /api/v4/me/getMe` — the app-shell identity plus the topbar counts.'
  )
